(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/iframe/assets/javascripts/init.js') >= 0) return;  svs.modules.push('/modules/iframe/assets/javascripts/init.js');

const loggingEnabled = svs.iframe.data.moduleConfig.enableLogging;
const isDev = svs.iframe.data.isDev;

const getElementPositionFromTop = (element) => {
  const rect = element.getBoundingClientRect();
  const scrollTop = window.scrollY || window.pageYOffset;
  const elementTop = rect.top + scrollTop;
  return Math.ceil(elementTop);
};

const init = () => {
  const iframeELe = document.getElementById('js-iframe');
  const dataAllowAdvancedMode = iframeELe.getAttribute('data-allow-advanced-mode');
  const offsetTop = getElementPositionFromTop(iframeELe);

  const setHeight = () => {
    const newHeight = Math.round(window.innerHeight - offsetTop);
    iframeELe.height = newHeight;
  };

  const setHeightOnLoad = () => {
    if (parseInt(iframeELe.height, 10) > 0) {
      window.requestAnimationFrame(setHeightOnLoad);
    } else {
      setHeight();
    }
  };

  if (dataAllowAdvancedMode === 'true') {
    document.querySelector('#js-iframe').onload = () => iFrameResize({ log: isDev && loggingEnabled, heightCalculationMethod: 'bodyScroll' });
  } else {
    setHeightOnLoad();
    window.addEventListener('resize', setHeight, false);
    window.addEventListener('orientationchange', setHeight, false);
  }
};

init();



 })(window);